// src/components/layout/Layout.tsx
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import MobileBottomDock from './MobileBottomDock';
import MobileMenuOverlay from './MobileMenuOverlay';
import OpeningHoursOverlay from './OpeningHoursOverlay';
import ErrorBoundary from '../ui/ErrorBoundary';
import { AnimatePresence } from 'framer-motion';

const Layout = () => {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col">
      {/* Skip to main content link for accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-red-800 text-white px-4 py-2 rounded-md z-[10000] focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
      >
        Skip to main content
      </a>

      <Header />
      {/* Add mobile-safe bottom padding so content isn't hidden behind the dock */}
      <main id="main-content" className="flex-grow pb-20 lg:pb-0" tabIndex={-1}>
        <ErrorBoundary>
          <AnimatePresence mode="wait">
            <div key={location.pathname}>
              <Outlet />
            </div>
          </AnimatePresence>
        </ErrorBoundary>
      </main>
      <Footer />
      {/* Bottom dock on ALL pages (mobile/tablet only) */}
      <div className="lg:hidden">
        <MobileBottomDock />
      </div>
      {/* Mobile Menu Overlay */}
      <MobileMenuOverlay />
      {/* Opening Hours Overlay */}
      <OpeningHoursOverlay />
    </div>
  );
};

export default Layout;
